import React from "react";

const Collaboration = ({ data }) => {
    if (!data || !Array.isArray(data)) return null;

    return (
        <section className=" contact-section">
            <div className="container">
                <div className="sec-title text-center">
                    <h2>Our Collaborations</h2>
                </div>

                <div className="row justify-content-center g-4">
                    {data.map((logo, index) => (
                        <div key={index} className="col-6 col-md-4 ">
                            <div className="event-card-interncare text-center">
                                <img 
                                    src={logo} 
                                    alt={`Collaboration ${index + 1}`} 
                                    className="event-logo"
                                    onError={(e) => {
                                        e.target.src = "https://via.placeholder.com/150x100?text=Logo";
                                    }}
                                    style={{ borderRadius: '10px', width: '150px', height: '130px', objectFit: 'contain' }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Collaboration;